
    
<div class="login_form">

  <div class="logo">
    <img src="../../../../../assets/images/logo/flowtrics_logo.png">
  </div>

  <div class="title">User already logged in</div>

  <div class="loginForm">
    <div class="logWrapper">    
      <div class="selectContact">
          <div class="userpic" >
            <!-- <ng-container *ngIf="ImagePathURL">
              <ng-container *ngIf="ImagePathURL.substring(0, 4) == 'http'; else showName" >              
                  <img src="{{ ImagePathURL }}" />            
              </ng-container>
              <ng-template #showName>
                <span class="shortName">
                  {{ getShortName(FullName) }}</span>
              </ng-template>
          </ng-container> -->
            <img src="../../../assets/images/avatars/andrew.jpg" alt="" />
          </div>
          <div class="detail">
            <h4>Surender Kumar</h4>
            <p>surender.dz@smartdatainc.net</p>
            <!-- <h4>{{FullName}}</h4>
            <p>{{Email}}</p> -->
          </div>
      </div>

      <div class="logot">
        <p>Please sign out to login with new account</p>

      <button mat-flat-button color="primary" (click)="logOutUser()">Logout</button>

      </div>
      
  </div>
  </div>

</div>
    






